export function hajjGarageTransferRefId(ref) {
  if (ref == null || ref === "") return "";
  if (typeof ref === "object" && ref._id != null) return String(ref._id);
  return String(ref);
}

export function resolveHajjGarageTransferShowReassignNote(trip, snapOverride) {
  if (!trip) return false;

  const snap =
    snapOverride ||
    trip.hajjGarageTransferPrint ||
    trip.hajjGarageTransferPrintPayload ||
    {};

  if (
    snap.showReassignNote === true ||
    trip.hajjGarageTransferReassignment === true ||
    trip.hajjGarageTransferReassignment === "true" ||
    trip.hajjGarageTransferShowReassignNote === true
  ) {
    return true;
  }

  const mainDriverId = hajjGarageTransferRefId(
    trip.mainDriver?._id ?? trip.mainDriver ?? trip.driver?._id ?? trip.driver,
  );
  const vehicle = trip.vehicle && typeof trip.vehicle === "object" ? trip.vehicle : {};
  const vehicleDriverId = hajjGarageTransferRefId(vehicle.driver);

  if (mainDriverId && vehicleDriverId) {
    return mainDriverId !== vehicleDriverId;
  }

  return false;
}

function resolveAssignedDriver(trip) {
  const md = trip?.mainDriver;
  const dr = trip?.driver;
  if (md && typeof md === "object" && (md._id || md.name || md.arabicName)) return md;
  if (dr && typeof dr === "object" && (dr._id || dr.name || dr.arabicName)) return dr;
  return {};
}

function buildVehiclePrintLine(vehicle) {
  if (!vehicle || typeof vehicle !== "object") return "";
  const opId = vehicle.operationalID != null ? String(vehicle.operationalID).trim() : "";
  const plate = vehicle.plateNumber ? String(vehicle.plateNumber).trim() : "";
  let line = opId ? `${opId}${plate ? ` - ${plate}` : ""}` : plate;
  if (vehicle.active === false && line) line += " (Inactive)";
  return line;
}

export function buildHajjGarageTransferPrintPayloadFromTrip(
  trip,
  {
    isLangRtl = true,
    destinationText = "—",
    serviceText = "—",
    vehicleTypeText = "",
  } = {},
) {
  const snap = trip?.hajjGarageTransferPrint || trip?.hajjGarageTransferPrintPayload || {};
  const md = resolveAssignedDriver(trip);
  const vd = trip?.vehicle && typeof trip.vehicle === "object" ? trip.vehicle : {};

  const drvLabel = md.name || md.arabicName
    ? isLangRtl
      ? md.arabicName || md.name
      : md.name || md.arabicName
    : "";
  const empId = md.employeeID != null ? String(md.employeeID).trim() : "";
  const snapEmpId = snap.driverEmployeeId != null ? String(snap.driverEmployeeId).trim() : "";
  const driverLine = drvLabel || empId || snapEmpId || "—";
  const opId = vd.operationalID != null ? String(vd.operationalID).trim() : "";
  const snapOpId = snap.vehicleOperationalId != null ? String(snap.vehicleOperationalId).trim() : "";
  const plate = vd.plateNumber ? String(vd.plateNumber) : "";
  const liveVehicleLine = buildVehiclePrintLine(vd);
  const vehicleLine = liveVehicleLine || String(snap.vehicleLine || "").trim() || "—";

  let resolvedVehicleType = String(vehicleTypeText || "").trim();
  if (!resolvedVehicleType) {
    const mk = vd.make
      ? isLangRtl
        ? vd.make.arabicName || vd.make.name
        : vd.make.name || vd.make.arabicName
      : "";
    const mdl = vd.model
      ? isLangRtl
        ? vd.model.arabicName || vd.model.name
        : vd.model.name || vd.model.arabicName
      : "";
    resolvedVehicleType = [mk, mdl].filter(Boolean).join(" ").trim();
  }
  if (!resolvedVehicleType) {
    resolvedVehicleType = String(snap.vehicleTypeText || "").trim();
  }

  const driverMobileNo =
    md.mobileNumber != null
      ? String(md.mobileNumber).trim()
      : snap.driverMobileNo != null
        ? String(snap.driverMobileNo).trim()
        : "";

  return {
    startTime:
      snap.startTime ||
      (trip?.scheduledStartDate && trip?.scheduledStartTime
        ? `${trip.scheduledStartDate} ${trip.scheduledStartTime}`
        : trip?.scheduledStartTime || trip?.scheduledStartDate || null),
    destinationText: destinationText || "—",
    serviceText: serviceText || "—",
    driverLine,
    driverEmployeeId: empId || snapEmpId,
    driverMobileNo,
    vehicleLine,
    vehicleOperationalId: opId || snapOpId,
    vehicleTypeText: resolvedVehicleType,
    showReassignNote: resolveHajjGarageTransferShowReassignNote(trip, snap),
  };
}
